import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAkPEYav_kWYys1vkb6V2BsijaVLnPzqP4",
  authDomain: "fractaliags.firebaseapp.com",
  projectId: "fractaliags",
  storageBucket: "fractaliags.appspot.com",
  messagingSenderId: "65600493607",
  appId: "1:65600493607:web:a5a046894c39d4cef35602",
  measurementId: "G-84FRQSG1VC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

